import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { ApiBaseUrl } from '../constants/global';

const Register = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${ApiBaseUrl}/register`, { username, email, password });
      alert("User registered successfully!");
      navigate("/login");
    } catch (err) {
      alert("Error registering user");
    }
  };

  return (
    <div className="config-main">
      <h2>Register</h2>
      <form onSubmit={handleRegister}>
        <div className="field">
            <label htmlFor="login-user">Username</label>
            <input
                id="login-user"
                type="text"
                placeholder="Username"
                onChange={(e) => setUsername(e.target.value)}
                required
            />
        </div>
        <div className="field">
            <label htmlFor="login-email">Email</label>
            <input
                id="login-email"
                type="email"
                placeholder="Email"
                onChange={(e) => setEmail(e.target.value)}
                required
            />
        </div>
        <div className="field">
            <label htmlFor="login-password">Password</label>
            <input
                id="login-password"
                type="password"
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
                required
            />
        </div>
        <div>
          <button type="submit">Register</button>
        </div>
      </form>
    </div>
  );
};

export default Register;